import * as types from "./mutation-types";

export const setTableMode = ({ commit }) => {
  commit(types.SET_TABLE_MODE);
};
export const setDetailsIsActive = ({ commit }, payload) => {
  commit(types.SET_DETAILS_IS_ACTIVE, payload);
};
export const setDetailsId = ({ commit }, payload) => {
  commit(types.SET_DETAILS_ID, payload);
};
export const setFiltersTabIsActive = ({ commit }, payload) => {
  commit(types.SET_FILTERS_TAB_IS_ACTIVE, payload);
};
export const setPreferencesModalIsActive = ({ commit }, payload) => {
  commit(types.SET_PREFERENCES_MODAL_IS_ACTIVE, payload);
};
export const setPreferencesId = ({ commit }, payload) => {
  commit(types.SET_PREFERENCES_ID, payload);
};

// FILTERS
export const setSearchFilter = ({ commit }, payload) => {
  commit(types.SET_SEARCH_FILTER, payload);
};
export const setActiveFilters = ({ commit }, payload) => {
  commit(types.SET_ACTIVE_FILTERS, payload);
};
export const clearFilters = ({ commit }) => {
  commit(types.CLEAR_FILTERS);
};
